import { render } from "./colorPickerModal.vue?vue&type=template&id=1cc2e3e2&scoped=true"
import script from "./colorPickerModal.vue?vue&type=script&lang=js"
export * from "./colorPickerModal.vue?vue&type=script&lang=js"

import "./colorPickerModal.vue?vue&type=style&index=0&id=1cc2e3e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc2e3e2"]])

export default __exports__